module.exports = __webpack_public_path__ + "rgfw4.png?5781e3ee76e4fcbd8cf79635340a0db4";


//////////////////
// WEBPACK FOOTER
// ./static/assets/rgfw4.png
// module id = 255
// module chunks = 0